import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { enumValues, nullable, string, timestamp } from "../../../types/_types";

import { ArticleRef } from "../../articles/types/ArticleRef";
import { ArtifactRef } from "../../artifacts/types/ArtifactRef";
import distributionStatuses from "../../distribution/constants/distributionStatuses";
import { OrganizationRef } from "../../organizations/types/OrganizationRef";
import { Pipeline } from "../../pipelines/types/Pipeline";

const exportStatus = enumValues(distributionStatuses).default(distributionStatuses.PENDING);

export const Export = FirestoreDocument.extend({
	name: string().default(""),
	artifact: ArtifactRef,
	article: ArticleRef.partial(),
	error: nullable(string()),
	pipeline: Pipeline,
	publisher: OrganizationRef,
	status: exportStatus,
	expires: timestamp(),
	startedAt: nullable(timestamp()),
	stoppedAt: nullable(timestamp()),
}).merge(FirestoreLifecycle);
